export const config = {
  base_url: import.meta.env.VITE_BASE_URL,
  image_base_url: import.meta.env.VITE_IMAGE_BASE_URL,
  image_optimized_base_url: import.meta.env.VITE_IMAGE_OPTIMIZED_BASE_URL,
  thirdparty_image_base_url: import.meta.env.VITE_THIRDPARTY_IMAGE_BASE_URL,
  original_game: import.meta.env.VITE_ORIGINAL_GAME,
  docs_url: import.meta.env.VITE_DOCS_URL,
  bridge_url: import.meta.env.VITE_BRIDGE_URL,
  promotion_url: import.meta.env.VITE_PROMOTION_URL,
  domain: import.meta.env.VITE_DOMAIN,
  origin: import.meta.env.VITE_ORIGIN,
  app_download_link: import.meta.env.VITE_APP_DOWNLOAD_LINK || "",
  currencyList: import.meta.env.VITE_CURRENCY_LIST?.split(',') || [],

  betby_library: import.meta.env.VITE_BETBY_LIBRARY,
  betby_brand_id: import.meta.env.VITE_BETBY_BRAND_ID,
  betby_support_currency: import.meta.env.VITE_BETBY_SUPPORT_CURRENCY,
  betby_theme_dark: import.meta.env.VITE_BETBY_THEME_DARK,
  betby_theme_light: import.meta.env.VITE_BETBY_THEME_LIGHT,
  sport_status: import.meta.env.VITE_SPORT_STATUS,
  fb_app_id: import.meta.env.VITE_FB_APP_ID || "",
  platform_id: Number(import.meta.env.VITE_PLATFORM_ID),

  web_title: import.meta.env.VITE_WEB_TITLE,
  platform_currency_ib: import.meta.env.VITE_PLATFORM_CURRENCY_IB,
  platform_currency_gb: import.meta.env.VITE_PLATFORM_CURRENCY_GB,
  lang: import.meta.env.VITE_LANG?.split(',') || [],

  poker_enabled: import.meta.env.VITE_POKER_ENABLED === 'true',
  mahjong_enabled: import.meta.env.VITE_MAHJONG_ENABLED === 'true',
  license_id: import.meta.env.VITE_LICENSE_ID,
  livechat_id: import.meta.env.VITE_LIVECHAT_ID,
  bridgeName: import.meta.env.VITE_BRIDGE_NAME,
  affiliateDashboard: import.meta.env.VITE_AFFILIATE_DASHBOARD || "",

  google_auth_client_id: import.meta.env.VITE_GOOGLE_AUTH_CLIENT_ID,
  enable_chat: import.meta.env.VITE_ENABLE_CHAT === 'true',
  is_disabled_chat: import.meta.env.VITE_IS_DISABLED_CHAT === 'true',

  gtm_container_id: import.meta.env.VITE_GTM_CONTAINER_ID,
  posthog_api_key: import.meta.env.VITE_POSTHOG,
};
